"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityHighlighter = void 0;
class IdentityHighlighter {
    highlight(line, pos) {
        return line;
    }
    highlightPrompt(prompt) {
        return prompt;
    }
    highlightChar(line, pos) {
        return false;
    }
}
exports.IdentityHighlighter = IdentityHighlighter;
//# sourceMappingURL=highlight.js.map